import {
  readLootCatalogItemAsItemDefinition,
  readShopTemplateAsItemDefinition,
} from './compat';

const toDisplayCategory = (definition) => definition?.sourceCategory || definition?.kind || 'misc';

const buildDisplayItem = (definition, extras = {}) => ({
  id: definition.definitionId,
  name: definition.name,
  category: toDisplayCategory(definition),
  rarity: definition.rarity || 'common',
  shortDesc: definition.authoredText.shortDesc,
  longDesc: definition.authoredText.longDesc,
  notes: definition.authoredText.notes,
  dmNotes: definition.authoredText.dmNotes,
  iconRef: definition.icon,
  tags: definition.tags,
  buffs: definition.authoredRules.buffs,
  debuffs: definition.authoredRules.debuffs,
  onUseEffects: definition.authoredRules.onUseEffects,
  combatBonuses: definition.authoredRules.combatBonuses,
  abilities: definition.authoredRules.abilities,
  uses: definition.authoredRules.usesTemplate,
  basePrice: definition.authoredEconomy.basePrice,
  tradeOnly: definition.authoredEconomy.tradeOnly,
  buffsApplyOnUse: definition.authoredRules.buffsApplyOnUse,
  definition,
  ...extras,
});

export const buildShopTemplateDisplayItem = (template = {}) => {
  const definition = readShopTemplateAsItemDefinition(template);
  return buildDisplayItem(definition, { _source: 'shop' });
};

export const buildLootCatalogDisplayItem = (item = {}) => {
  const definition = readLootCatalogItemAsItemDefinition(item);
  return buildDisplayItem(definition, { _source: 'loot' });
};

export const buildShopTemplateDisplayMap = (templates = {}) => Object.fromEntries(
  Object.values(templates).map((template) => {
    const displayItem = buildShopTemplateDisplayItem(template);
    return [displayItem.id, displayItem];
  }),
);

export const buildLootCatalogDisplayMap = (items = {}) => Object.fromEntries(
  Object.values(items).map((item) => {
    const displayItem = buildLootCatalogDisplayItem(item);
    return [displayItem.id, displayItem];
  }),
);

export const buildUnifiedItemCatalogDisplayMap = ({
  lootItems = {},
  shopTemplates = {},
} = {}) => ({
  ...buildShopTemplateDisplayMap(shopTemplates),
  ...buildLootCatalogDisplayMap(lootItems),
});
